import normalize, { questionBlockSchema } from 'schema';
import {
  START_OR_RESUME_SURVEY,
  START_OR_RESUME_SURVEY_SUCCESS,
  START_OR_RESUME_SURVEY_FAILURE,
  COMMIT_QUESTION_BLOCK,
  COMMIT_QUESTION_BLOCK_SUCCESS,
  COMMIT_QUESTION_BLOCK_FAILURE,
  COMPLETE_SURVEY,
  GET_BLOCK,
  GET_BLOCK_SUCCESS,
} from 'actionTypes';

export function startOrResumeSurvey() {
  return {
    type: START_OR_RESUME_SURVEY,
  };
}

export function startOrResumeSurveySuccess(response) {
  return {
    type: START_OR_RESUME_SURVEY_SUCCESS,
    normalizedData: normalize(response.payload, questionBlockSchema),
  };
}

export function startOrResumeSurveyFailure(response) {
  return {
    type: START_OR_RESUME_SURVEY_FAILURE,
  };
}

export function commitQuestionBlock(blockId) {
  return {
    type: COMMIT_QUESTION_BLOCK,
    endpointArgs: { blockId },
  };
}

export function commitQuestionBlockSuccess(response) {
  return {
    type: COMMIT_QUESTION_BLOCK_SUCCESS,
    normalizedData: normalize(response.payload, questionBlockSchema),
  };
}

export function commitQuestionBlockFailure(response) {
  return {
    type: COMMIT_QUESTION_BLOCK_FAILURE,
  };
}

export function completeSurvey() {
  return {
    type: COMPLETE_SURVEY,
  };
}

export function getBlock(blockId) {
  return {
    type: GET_BLOCK,
    endpointArgs: { blockId },
  };
}

export function getBlockSuccess(response) {
  return {
    type: GET_BLOCK_SUCCESS,
    normalizedData: normalize(response.payload, questionBlockSchema),
  };
}



// WEBPACK FOOTER //
// ./src/actions/surveyActions.js